import "@/monitoring/sentry";
import "@/monitoring/posthog";
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@mivo/i18n/init";
import { bootstrapMultiLanguage, fetchIsMultiLanguageEnabled } from "@mivo/i18n";
import { registerAppServiceWorker } from "@/registerAppServiceWorker";
import { API } from "@/domains/shared/services/api";
import "@/index.css";
import App from "@/App";
import { AppProviders } from "@/app/providers";
import { BrowserRouter } from "react-router";
import { ErrorFallback } from "@/monitoring/ErrorFallback";

registerAppServiceWorker();

void bootstrapMultiLanguage(() => fetchIsMultiLanguageEnabled(API)).then(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={({ error }) => <ErrorFallback error={error} />}>
        <BrowserRouter>
          <AppProviders>
            <App />
          </AppProviders>
        </BrowserRouter>
      </Sentry.ErrorBoundary>
    </React.StrictMode>,
  );
});
